// src/pages/DashboardPage.tsx
import { useEffect, useState } from 'react';

import ChannelListPage from '../components/channels/ChannelListPage';

export type SidebarState = 'open' | 'narrow' | 'closed';

export default function DashboardPage() {
  const [sidebarState, setSidebarState] = useState<SidebarState>('open');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarState('closed'); // Default to closed on mobile
      } else {
        // Restore last desktop state or default to 'open'
        const lastDesktopState = localStorage.getItem('sidebarDesktopState') as SidebarState | null;
        setSidebarState(lastDesktopState || 'open');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Persist desktop sidebar state
    if (!isMobile) {
      localStorage.setItem('sidebarDesktopState', sidebarState);
    }
  }, [sidebarState, isMobile]);




  return (
    <ChannelListPage />
  );
}
